import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "@/assets/logo-negocio-conectado.webp";
import { WHATSAPP_URL } from "@/lib/constants";

const NAV_ITEMS = [
  { label: "Início", href: "/" },
  { label: "Telemedicina", href: "/telemedicina" },
  { label: "Blog", href: "/blog" },
];

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-40 border-b border-border/50 bg-background/90 backdrop-blur-md">
      <div className="container flex h-16 items-center justify-between md:h-20">
        <Link to="/" className="flex-shrink-0">
          <img src={logo} alt="Negócio Conectado" width={256} height={80} fetchPriority="high" className="h-14 w-auto md:h-16" />
        </Link>

        <nav className="hidden items-center gap-1 lg:flex">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className="rounded-md px-3 py-2 text-sm font-medium text-foreground/80 transition-colors hover:text-primary"
            >
              {item.label}
            </Link>
          ))}
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="ml-4 inline-flex items-center rounded-lg bg-gradient-orange px-5 py-2.5 text-sm font-semibold text-primary-foreground shadow-button transition-transform hover:scale-105"
          >
            Fale Conosco
          </a>
        </nav>

        <button
          onClick={() => setOpen(!open)}
          className="rounded-md p-2 text-foreground lg:hidden"
          aria-label="Menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <nav className="border-t border-border bg-background px-4 pb-6 pt-2 lg:hidden">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              onClick={() => setOpen(false)}
              className="block rounded-md px-3 py-3 text-base font-medium text-foreground/80 transition-colors hover:text-primary"
            >
              {item.label}
            </Link>
          ))}
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 block rounded-lg bg-gradient-orange px-5 py-3 text-center text-base font-semibold text-primary-foreground shadow-button"
          >
            Fale Conosco
          </a>
        </nav>
      )}
    </header>
  );
};

export default Header;
